<script>
import axios from '@/utils/axios';
import Permissions from '@/utils/permissions.js';
import { createSiteInspection } from '@/utils/site-inspection';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore'

export default {
 inject: ['setLoading'], 
 data() {
  return {
    loading: true,
   title: "Customers",
   text: "CRM",
   data: [],
   users: [],
   sources: [],
   user: '',
   source: '',
   search_keyword: '',
   selected_rows: [],
   pagination: {
    current_page: 1,
    per_page: 25,
    last_page: 1,
    total: 0,
    links: []
   },
   permissions: Permissions,
   client_type: 'App\\Models\\Customer'
  };
 },

 computed: {
  text1(){
   return `Customers (${this.pagination.total})`; 
  },
  allSelected() {
   return this.data?.length && this.selected_rows.length === this.data.length;
  },
    isDcVisibilityEnabled() {
    const setting = JSON.parse(localStorage.getItem('client_setting') || '{}');
    return setting.dc_customer_visibility_control == 1;
  },
 },

 async mounted() {
  await this.loadMeta();
  // this.getUsers();
  // this.getSources();
  this.customers();
  await Permissions.init();
 },

 methods: {

   async loadMeta() {
  const store = useLeadMetaStore()
  await store.loadAll()
  this.sources = store.sources
  this.users   = store.users
},

  async createSiteInspection(customerId) {
    this.setLoading(true)
    try {
        const res = await createSiteInspection({
            party_type: 'App\\Models\\Customer',
            party_id: customerId
        })
        this.$swalToast(res.data.message)
    } catch (error) {
        if (error.type === 'validation') {
            const firstError = Object.values(error.errors)[0]
            this.$swalToast(firstError[0], 'error')
        } else {
            this.$swalToast(error.message, 'error')
        }
    } finally {
        this.setLoading(false)
    }
},

async toggleDcVisibility(row) {
  try {
    const result = await this.$swal({
      title: row.is_visible_in_dc ? 'Hide from DC?' : 'Show in DC?',
      text: `Are you sure you want to ${row.is_visible_in_dc ? 'hide' : 'show'} "${row.company_name}" in Delivery Challans?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: row.is_visible_in_dc ? 'Yes, Hide' : 'Yes, Show',
      cancelButtonText: 'Cancel',
      confirmButtonColor: row.is_visible_in_dc ? '#e84040' : '#22c55e',
    });
    if (result.isConfirmed) {
      this.setLoading(true);
      const response = await axios.patch(`/customers/${row.id}/visibility-status-in-dc`);
      this.$swalToast(response.data.message);
      row.is_visible_in_dc = row.is_visible_in_dc ? 0 : 1;
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},


  handleToggleAll(event) {
   this.selected_rows = this.$toggleAll(event, this.data);
  },

  // async getSources(){
  // //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/lead-sources');
  //   this.sources = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  // async getUsers(){
  // //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/users/all-users');
  //   this.users = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  async customers(page = 1, append = false){
    this.loading = true;
  //  this.setLoading(true);
   try{
    const params = {
     page,
     user_id: this.user || '',
     lead_source_id: this.source || '',
     search_keyword: this.search_keyword.trim() || ''
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/customers?${query_string}`);
    const new_data = response.data.data.data;
    if(append){
     this.data = [...this.data, ...new_data];
    }else{
     this.data = new_data;
    }
    this.pagination = {
     current_page: response.data.data.current_page,
     per_page: response.data.data.per_page,
     last_page: response.data.data.last_page,
     total: response.data.data.total,
     links: response.data.data.links 
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.loading = false;
    // this.setLoading(false);
   }
  },

  loadMore(){
   // Only load more if not already at last page
   if(this.pagination.current_page < this.pagination.last_page){
    const nextPage = this.pagination.current_page + 1;
    this.customers(nextPage, true); // append = true
   }
  },

  clearFilter(){
   this.user = '';
   this.source = '';
   this.search_keyword = '';
   this.customers();
  },

  async exportFile(){
   this.setLoading(true);
   try{
    const response = await axios.get('/customers/export/excel', {
     responseType: 'blob'
    });
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    // Create a link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    // Extract filename from Content-Disposition header if available
    let filename = `customers_export_${this.$timeStamp()}.xlsx`;  // fallback default
    const disposition = response.headers['content-disposition'];
    if(disposition && disposition.indexOf('filename=') !== -1){
    const filenameMatch = disposition.match(/filename="?(.+)"?/);
    if (filenameMatch.length === 2) filename = filenameMatch[1];
    }
    link.download = filename;
    // Append to body and trigger click to download
    document.body.appendChild(link);
    link.click();
    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
   }catch(error){
    console.log(error.message);
   }finally{
    this.setLoading(false); 
   }
  },

 },
};
</script>

<style scoped>
/* ── FILTER BAR ── */
.c-filter-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; cursor: pointer;
  transition: border-color .15s; min-width: 120px;
}
.c-filter-select:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
 
.c-search-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  overflow: hidden; background: #fff;
}
.c-search-wrap:focus-within { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.c-search-input {
  border: none; outline: none; height: 34px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  width: 190px; background: transparent;
}
.c-search-btn {
  width: 36px; height: 36px; background: #0f172a;
  border: none; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; transition: background .15s;
}
.c-search-btn:hover { background: #1e293b; }
 
.c-clear-btn {
  width: 34px; height: 34px; background: #fff0f3;
  border: 1.5px solid #fecdd3; border-radius: 8px;
  color: #f43f5e; font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.c-clear-btn:hover { background: #f43f5e; color: #fff; border-color: #f43f5e; }
 
/* ── CUSTOMER CARD ── */
.c-card {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: visible;
  display: flex;
  flex-direction: column;
  transition: box-shadow .2s, border-color .2s, transform .2s;
  height: 100%;
  position: relative;
}
.c-card:hover {
  box-shadow: 0 8px 24px rgba(99,102,241,.1);
  border-color: #c7d2fe;
}
 
 
.c-card-body {
  padding: 18px 16px 14px;
  flex: 1;
}
 
/* Dropdown inside card — force above everything */
.c-card .dropdown-menu {
  z-index: 9999 !important;
  position: absolute !important;
}
 
/* Header row — checkbox + avatar + dropdown */
.c-card-head {
  display: flex; align-items: flex-start;
  justify-content: space-between; margin-bottom: 14px;
}
 
/* Avatar */
.c-avatar {
  width: 52px; height: 52px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 700; color: #fff;
  flex-shrink: 0; text-decoration: none;
  transition: transform .15s;
}
.c-avatar:hover { transform: scale(1.05); }
 
/* Company name */
.c-company {
  font-size: 13.5px; font-weight: 700; color: #0f172a;
  text-decoration: none; transition: color .15s;
  display: block; text-align: center;
}
.c-company:hover { color: #6366f1; }
 
.c-person {
  font-size: 11.5px; color: #94a3b8;
  text-align: center; margin-top: 2px;
}
 
/* Divider */
.c-divider {
  height: 1px; background: #f1f5f9; margin: 12px 0;
}
 
/* Info rows */
.c-info-row {
  display: flex; align-items: center; gap: 8px;
  font-size: 12px; color: #475569; margin-bottom: 7px;
  overflow: hidden;
}
.c-info-row:last-child { margin-bottom: 0; }
.c-info-row i { font-size: 14px; flex-shrink: 0; }
.c-info-text {
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
 
/* Footer */
.c-card-footer {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 16px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
  border-radius: 0 0 14px 14px;
  flex-shrink: 0;
}
.c-source-badge {
  font-size: 10.5px; color: #475569;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 20px; padding: 2px 10px;
  font-weight: 500;
}
.c-icon-link {
  width: 28px; height: 28px; border-radius: 8px;
  background: #eff6ff; border: 1px solid #bfdbfe;
  display: inline-flex; align-items: center; justify-content: center;
  color: #3b82f6; font-size: 13px; text-decoration: none;
  transition: all .15s;
}
.c-icon-link:hover { background: #3b82f6; color: #fff; border-color: #3b82f6; }
 
/* Load More button */
.c-load-more {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 9px 24px; border-radius: 10px;
  background: #fff; border: 1.5px solid #e2e8f0;
  font-size: 13px; font-weight: 600; color: #475569;
  cursor: pointer; transition: all .15s; text-decoration: none;
}
.c-load-more:hover {
  background: #eff6ff; border-color: #bfdbfe; color: #6366f1;
}
</style>
 
<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper">
<div class="content">
 
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
 
      <!-- Export -->
      <div v-if="data?.length">
        <div class="dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile">
                <i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
 
      <!-- Add Customer -->
      <a href="javascript:void(0);"
        data-bs-toggle="modal" data-bs-target="#customer_modal"
        class="btn btn-primary d-flex align-items-center"
        @click="$refs.customerModal.add();">
        <i class="ti ti-circle-plus me-2"></i>Add Customer
      </a>
 
    </div>
  </div>
  <!-- /Breadcrumb -->
 
  <!-- Filter Card -->
  <div class="card border-0 shadow-sm mb-4" style="border-radius:14px;">
    <div class="card-body py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
 
      <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
        Customers
        <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
      </h5>
 
      <div class="d-flex align-items-center flex-wrap gap-2">
 
        <!-- Clear -->
        <button
          v-if="search_keyword !== '' || source !== '' || user !== ''"
          class="c-clear-btn" @click="clearFilter()" title="Clear filters">
          <i class="ti ti-filter-x"></i>
        </button>
 
        <!-- Source -->
        <vue-select
          v-model="source"
          :options="sources"
          label="name"
          :reduce="r => r.id"
          placeholder="Source"
          :clearable="true"
          @update:modelValue="customers()"
          style="min-width: 150px;"
        ></vue-select>

        <!-- Assigned -->
        <vue-select
          v-model="user"
          :options="users"
          label="name"
          :reduce="r => r.id"
          placeholder="Assigned"
          :clearable="true"
          @update:modelValue="customers()"
          style="min-width: 150px;"
        ></vue-select>
 
        <!-- Search -->
        <div class="c-search-wrap">
          <input type="text" class="c-search-input" v-model="search_keyword" placeholder="Search customers..."
            @keyup.enter="customers()" />
          <button class="c-search-btn" type="button" @click="customers()">
            <i class="ti ti-search"></i>
          </button>
        </div>
 
      </div>
    </div>
  </div>
 
<!-- Skeleton -->
<app-skeleton v-if="loading" type="cards" :count="8" cardClass="col-xl-3 col-lg-4 col-md-6" />

  <!-- Customer Cards Grid -->
  <div class="row g-3 pb-3" v-else-if="data?.length">
    <div class="col-xl-3 col-lg-4 col-md-6" v-for="(row, index) in data" :key="row.id">
      <div class="c-card">
 
        <div class="c-card-body">
 
          <!-- Head: checkbox | avatar | dropdown -->
          <div class="c-card-head">
 
            <!-- Checkbox -->
            <div class="form-check form-checkbox-success mb-0">
              <input type="checkbox" class="form-check-input" :value="row.id" v-model="selected_rows" />
            </div>
 
            <!-- Avatar — null-safe -->
            <a :href="`crm/customers-details/${row.id}`" target="_blank" class="c-avatar"
              :style="{ background: `hsl(${((row.company_name || row.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }">
              {{ $firstLetter(row.company_name || row.name) }}
            </a>
 
            <!-- Dropdown -->
            <div class="dropdown">
              <button class="btn btn-icon btn-sm rounded-circle" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="ti ti-dots-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#customer_modal"
                    @click="$refs.customerModal.edit(row.id);">
                    <i class="ti ti-edit me-1"></i>Edit
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateQuotation">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#quotation_modal"
                    @click="$refs.quotationModal.createViaParty(client_type, row.id)">
                    <i class="ti ti-file-check me-1"></i>Create Quotation
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateProforma">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#proforma_invoice_modal"
                    @click="$refs.proformaInvoiceModal.createViaParty(client_type, row.id)">
                    <i class="ti ti-file-check me-1"></i>Create Proforma Invoice
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateSampling">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#sampling_modal"
                    @click="$refs.samplingModal.createViaParty(client_type, row.id)">
                    <i class="ti ti-file-check me-1"></i>Create Sampling Request
                  </a>
                </li>
                <li v-if="permissions.isLoaded && permissions.canCreateSalesOrder">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#sales_order_modal"
                    @click="$refs.salesOrderModal.createViaParty(client_type, row.id)">
                    <i class="ti ti-file-check me-1"></i>Create Sales Order
                  </a>
                </li>
                <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                      @click="createSiteInspection(row.id)">
                      <i class="ti ti-clipboard-check me-1"></i>Create Site Inspection
                  </a>
              </li>
              <li>
                <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#payment_add_modal"
                    @click="$refs.paymentAddModal.create(row.id)">
                    <i class="ti ti-receipt-rupee me-1"></i>Add Payment
                </a>
              </li>
              <li>
                <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#customer_dispatch_modal"
                    @click="$refs.dispatchModal.openCreateForCustomer(row.id)">
                    <i class="ti ti-truck-delivery me-1"></i>Add Customer Dispatch
                </a>
              </li>
                <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#customer_assign_modal"
                    @click="$refs.customerModal.assignForm(row.id);">
                    <i class="ti ti-user-star me-1"></i>Assign To User
                  </a>
                </li>
                <li v-if="isDcVisibilityEnabled">
                <a class="dropdown-item rounded-1" href="javascript:void(0);"
                  @click="toggleDcVisibility(row)">
                  <i :class="row.is_visible_in_dc ? 'ti ti-eye-off me-1' : 'ti ti-eye me-1'"></i>
                  {{ row.is_visible_in_dc ? 'Hide from DC' : 'Show in DC' }}
                </a>
              </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);"
                    data-bs-toggle="modal" data-bs-target="#customer_delete_modal"
                    @click="$refs.customerModal.edit(row.id);">
                    <i class="ti ti-trash me-1"></i>Delete
                  </a>
                </li>
              </ul>
            </div>
 
          </div>
 
          <!-- Company name + person -->
          <div class="text-center mb-3">
            <router-link :to="{ name: 'customers-details', params: { id: row.id } }" class="c-company">
              {{ row.company_name }}
            </router-link>
            <div class="c-person">
              <i class="ti ti-user" style="font-size:11px;"></i>
              {{ row.salutation }} {{ row.name }}
            </div>
          </div>
 
          <div class="c-divider"></div>
 
          <!-- Info rows -->
          <div class="c-info-row">
            <i class="ti ti-mail" style="color:#22c55e;"></i>
            <span class="c-info-text">{{ row.email }}</span>
          </div>
          <div class="c-info-row">
            <i class="ti ti-phone" style="color:#6366f1;"></i>
            <span class="c-info-text">{{ row.mobile }}</span>
          </div>
          <div class="c-info-row">
            <i class="ti ti-map-pin" style="color:#f59e0b;"></i>
            <span class="c-info-text">
              {{ row.city }}<span v-if="row.city && row.state">, </span>{{ row.state }}
            </span>
          </div>
 
        </div>
 
        <!-- Card Footer -->
        <div class="c-card-footer">
          <div class="d-flex align-items-center gap-1">
            <a v-if="row.website" :href="row.website" class="c-icon-link" target="_blank" title="Website">
              <i class="ti ti-world-www"></i>
            </a>
            <router-link v-if="row.lead_id" :to="{ name: 'leads-details', params: { id: row.lead_id } }"
              class="c-icon-link" title="Reference Lead" target="_blank">
              <i class="ti ti-user-check"></i>
            </router-link>
          </div>
          <span class="c-source-badge">{{ row.source?.name }}</span>
        </div>
 
      </div>
    </div>
  </div>
 
  <!-- Empty State -->
  <div v-else class="text-center py-5" style="color:#94a3b8;">
    <i class="ti ti-users" style="font-size:40px; display:block; margin-bottom:10px; opacity:.3;"></i>
    No customers found.
  </div>
 
  <!-- Load More -->
  <div class="text-center py-4" v-if="pagination.current_page < pagination.last_page">
    <a href="javascript:void(0);" class="c-load-more" @click="loadMore">
      <i class="ti ti-loader-3 text-primary"></i> Load More
    </a>
  </div>
 
</div>
 
<app-footer></app-footer>
</div>
 
<sampling-modal ref="samplingModal"></sampling-modal>
<proposal-modal ref="proposalModal"></proposal-modal>
<quotation-modal ref="quotationModal"></quotation-modal>
<customers-modal ref="customerModal" @updated="customers"></customers-modal>
<proforma-invoice-modal ref="proformaInvoiceModal"></proforma-invoice-modal>
<sales-order-modal ref="salesOrderModal" @updated="customers"></sales-order-modal>
<customer-dispatch-modal ref="dispatchModal" @updated="customers"></customer-dispatch-modal> 
<payment-add-modal ref="paymentAddModal"></payment-add-modal>
 
</template>
